import { Component, OnInit } from '@angular/core';
import { GetResTermOfUse } from '../../models/response/get-res-term-of-use';
import { TermsOfUseService } from '../../services/terms-of-use.service';
import { PostReqTermAcceptance } from '../../models/request/post-req-term-acceptance';
import { Router } from '@angular/router';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.css'],
    standalone: false
})
export class TermsOfUseComponent implements OnInit {

  accepted: boolean = false;
  termOfUse!: GetResTermOfUse;
  isLoading: boolean = true;

  constructor(
    private termsOfUseService: TermsOfUseService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getUserTermAcceptance();
    this.getTermOfUse();
  }

  getUserTermAcceptance(){
    const userId = localStorage.getItem('idSub');

    if(userId){
      this.termsOfUseService.getUserTermAcceptance(userId).subscribe({
        next: (res) => {
          if (res && res?.active !== false){
            this.router.navigate(['/home']);
          }
        },
        error: (err) => {
          console.error('Error fetching user term acceptance:', err);
        }
      });
    }
  }

  getTermOfUse(){
    this.termsOfUseService.getTermOfUse().subscribe({
      next: (res) => {
        this.termOfUse = res;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching terms of use:', err);
        this.isLoading = false;
      }
    })
  }

  cancel(){
    this.router.navigate(['/login']);
  }

  postTermAcceptance(){
    const userId = localStorage.getItem('idSub');
    const termId = this.termOfUse.id;

    if(userId && termId){
      const body: PostReqTermAcceptance = {
        userId: userId,
        termId: termId
      };

      this.termsOfUseService.postTermAcceptance(body).subscribe({
        next: () => {
          this.router.navigate(['/home']);
        },
        error: (err) => {
          console.error('Error posting term acceptance:', err);
        }
      });
    }
  }
}
